<template>
  <div class="page-content-wrapper">
    <div class="col-sm-12">
      <div class="row g-4">
        <div class="col-md-4 mb-2 mt-4">
          <icon-card
            title="Total Customers"
            :count="total_customer_count"
            icon_class="fa fa-users"
            @click="view_all_customers"
          ></icon-card>
        </div>
      </div>

      <div>
        <div class="card rounded-3 border-1 shadow mt-3">
          <div
            class="card-header bg-white border-0 d-flex justify-content-between align-items-center"
          >
            <p class="text-s fw-bold">Customers in your workflow</p>
          </div>
          <div class="card-body">
            <CustomTable
              :columns="columns"
              :fetchData="fetch_workflow_customers"
              :hasActions="true"
              tableKey="workflow_customers"
            >
              <template v-slot:cell-name_email="{ row }">
                {{ row.first_name || row.full_name }} {{ row.last_name || "" }}
                <p class="text-xxs fw-bold">{{ row.email }}</p>
              </template>
              <template v-slot:cell-date_joined="{ row }">
                {{ formatDate(row.date_joined) }}
              </template>
              <template v-slot:actions="{ row }">
                <button
                  class="btn bg-green btn-sm text-xxs secondary-text-dark fw-bold rounded-pill"
                  @click="view_customer_applications(row.id)"
                >
                  View
                </button>
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script src="./ViewWorkflow.js"></script>

